var _style, _line, _polyline, _path, _rect, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFileWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 34.4",
    style: {
      enableBackground: "new 0 0 30 34.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:2.3505;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:2.4934;stroke-miterlimit:10;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:none;}\r\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 5.7,
    y1: 8,
    x2: 19.3,
    y2: 8
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "15.1,24.3 18.5,27.5 25.1,21.4 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.1,16.8c4.2,0,7.6,3.4,7.6,7.6s-3.4,7.6-7.6,7.6s-7.6-3.4-7.6-7.6S15.9,16.8,20.1,16.8 M20.1,14.5 c-5.5,0-9.9,4.5-9.9,9.9s4.5,9.9,9.9,9.9s9.9-4.5,9.9-9.9S25.6,14.5,20.1,14.5C20.1,14.5,20.1,14.5,20.1,14.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.2,
    y: 0,
    className: "st3",
    width: 32.7,
    height: 33.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.5,33.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.5,13.2l0-8.9c0-2.4-2-4.3-4.4-4.3L4.3,0.2c-2.4,0-4.4,2-4.3,4.4l0.1,29.7l13.4-0.1l-2.5-2.4l-8.5,0.1 c0,0-0.1-19.3,0-26.2c0-0.9-0.2-3.2,1.8-3.2c2,0,16.2-0.1,16.2-0.1s2.5-0.3,2.6,3.2c0.1,5.4,0,7.6,0,7.6H25.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.4,13.5c0,0-2.1,0.7-3.8,2.5H5.7v-2.5H15.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M9.2,21c0,0-0.3,0.8-0.3,2.5l-3.1-0.1v-2.5L9.2,21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileWhite);
export default __webpack_public_path__ + "static/media/uploadFileWhite.c807c54dfa7288ce19a4c3b0333c05ee.svg";
export { ForwardRef as ReactComponent };